(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["NB-megamenu-container"]) return;
  try {
    
$(window).on('load', function(){
  var navFooter = $('.nbmega-mobfooter-dummy').detach();
  $(navFooter).removeClass('nbmega-mobfooter-dummy').addClass('nbmega-mobfooter');
  $('.nbmega-navitems').append($(navFooter).clone());
  $('.nbmega-navitem--submenu li:first-child').each(function() {
    $(this).append($(navFooter).clone());
  })
  $('.nbmega-navitem--submenu-linklist').each(function() {
    $(this).append($(navFooter).clone());
  })
  if (window.innerWidth <= 1024) {
    var barHeight = $('.announcement-bar').outerHeight();
    if (barHeight > 36){
      var diff = barHeight - 36;
      $('.site-main').css('margin-top', (parseInt($('.site-main').css('margin-top').replace('px', '')) + diff).toString() + 'px');
      $('.mobSearch').css('top', (parseInt($('.mobSearch').css('top').replace('px', '')) + diff).toString() + 'px');
    }
  }
  if (window.global_vars.template == 'collection'){
    if (!($('.nb-page-content > #shopify-section-static-footer-2019').length)){
      $('#shopify-section-static-footer-2019').detach().appendTo('.nb-page-content');
    }
  }
})
var opened = [];
var searchOpen = false;

$('.nbmega-container')[0].addEventListener('keydown', (evt) => {
  evt = evt || window.event;
  isEscape = ("key" in evt && /^Esc(ape)?/.test(evt.key)) || evt.keyCode === 27;
  if (isEscape) {
    $(evt.target).parent().removeClass('nbmega-navitem-menuopen');
    $('.nbmega-navitem').removeClass('nohover');
  }
});

function toggleMenu() {
  var body = $('body');
  var mobSearch = $('.mobSearch');
  var openSearch = $('.openSearch');
  var headerMenuToggle = $('.nb-site-header-menu-toggle');
  var nbmegaContainer = $('.nbmega-container');
  var pageContent = $('.nb-page-content');
  var nbmegaNavitems = $('.nbmega-navitems');

  body.toggleClass('showHeaderSearch');
  mobSearch.toggleClass('menu-open');
  openSearch.toggle();
  headerMenuToggle.toggleClass('open');
  nbmegaContainer.toggleClass('mob-visible');
  pageContent.toggleClass('menu-open');
  nbmegaNavitems.css('visibility', 'visible');
}

$('.nb-site-header-menu-toggle').click(toggleMenu);
$('.nbmega-container').click(function(e) {
  if ($(e.target).hasClass('nbmega-container')){
    toggleMenu();
  }
});
  
$('.nbmega-navitem--submenu-back').click(function(e) {
  var windowWidth = window.innerWidth;
  var target = $(e.target);
  var parent = target.closest('.has-dropdown');

  if (windowWidth > 1024 && parent.length) {
    e.preventDefault();
    parent.removeClass('nbmega-navitem-menuopen');
    $('.nbmega-navitem').removeClass('nohover');
  }
});

$('.nbmega-container a').click(function(e) {
  var windowWidth = window.innerWidth;
  var target = $(e.target);
  var parent = target.parent();
  var hasDropdown = parent.hasClass('has-dropdown');

  if (windowWidth > 1024 && hasDropdown) {
    e.preventDefault();
    var isOpen = parent.hasClass('nbmega-navitem-menuopen');
    $('.nbmega-navitem-menuopen').removeClass('nbmega-navitem-menuopen');
    if (!isOpen) {
      parent.addClass('nbmega-navitem-menuopen');
      $('.nbmega-navitem').addClass('nohover');
    } else {
      $('.nbmega-navitem').removeClass('nohover');
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcements-bar"] && !Shopify.designMode) return;
  try {
    
  window.innerWidth > 890 ? $('.mainTitleImg').addClass('lazy_load') : $('.mainTitleImgMob').addClass('lazy_load');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-goto-header-refresh"] && !Shopify.designMode) return;
  try {
    
$('a[href*="#"]')
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top - 80
          }, 500, function() {
            var $target = $(target);
            $target.focus();
            if ($target.is(':focus')) { 
              return false;
            } else {
              $target.attr('tabindex','-1'); 
              $target.focus(); 
            };
          });
        }
      }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  var url = window.innerWidth > 767 ? $('.newSletterSection').attr('data-url') : $('.newSletterSection').attr('data-mob-url');
  window.addEventListener('load', function(){
    $('.newSletterSection').css('background-image', 'url(' + url + ')');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter_klaviyo"] && !Shopify.designMode) return;
  try {
    
  var url = window.innerWidth > 767 ? $('.newSletterSection').attr('data-url') : $('.newSletterSection').attr('data-mob-url');
  window.addEventListener('load', function(){
    $('.newSletterSection').css('background-image', 'url(' + url + ')');
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["static-featured-collection"] && !Shopify.designMode) return;
  try {
    
if (window.innerWidth < 768){
  $('.static-featured-collection--container > .home-section--content').attr('data-flickity', '{ "cellAlign": "left", "contain": true, "prevNextButtons": false, "pageDots": false }');
}

  } catch(e) { console.error(e); }
})();
})();
